// Helpers for parsing YouTube / Vimeo source URLs the admin pastes in.
// We don't auto-fetch metadata — keep it simple and explicit.
import { parseYouTubeId } from "@/lib/youtube";

export const CINEMA_CATEGORIES = [
  { slug: "films", label: "Films & Movies" },
  { slug: "documentaries", label: "Documentaries" },
  { slug: "kids", label: "Kids & Family" },
  { slug: "sermons", label: "Sermons & Teaching" },
  { slug: "worship", label: "Worship & Music" },
  { slug: "series", label: "Bible Series" },
];

export function parseVimeoId(input) {
  if (!input) return null;
  const s = String(input).trim();
  if (/^\d{6,12}$/.test(s)) return s;
  try {
    const u = new URL(s);
    if (u.hostname.includes("vimeo.com")) {
      const m = u.pathname.match(/(\d{6,12})/);
      if (m) return m[1];
    }
  } catch {
    return null;
  }
  return null;
}

// Detect source type + ID from a user-pasted URL/ID. Returns
// { source_type, source_id } or null if it can't be parsed.
export function detectSource(input) {
  if (!input) return null;
  const yt = parseYouTubeId(input);
  if (yt) return { source_type: "youtube", source_id: yt };
  const vm = parseVimeoId(input);
  if (vm) return { source_type: "vimeo", source_id: vm };
  return null;
}

export function embedUrl({ source_type, source_id }) {
  if (!source_type || !source_id) return null;
  if (source_type === "youtube") {
    return `https://www.youtube.com/embed/${source_id}?rel=0&modestbranding=1`;
  }
  if (source_type === "vimeo") {
    return `https://player.vimeo.com/video/${source_id}?title=0&byline=0&portrait=0`;
  }
  return null;
}
